// Toasts: short verdicts and notices, announced through aria-live (§9.16).
import { signal } from '@preact/signals';
import { useEffect } from 'preact/hooks';
import { Rich } from './RichText.tsx';

export interface ToastItem {
  id: number;
  tone: 'correct' | 'wrong' | 'info';
  text: string;
}

export const toasts = signal<ToastItem[]>([]);
let next = 1;

export function showToast(tone: ToastItem['tone'], text: string, ms = 3200): void {
  const id = next++;
  toasts.value = [...toasts.value.slice(-2), { id, tone, text }];
  setTimeout(() => {
    toasts.value = toasts.value.filter((t) => t.id !== id);
  }, ms);
}

export function ToastHost() {
  useEffect(() => () => void (toasts.value = []), []);
  return (
    <div class="toast-host" role="status" aria-live="polite" aria-atomic="false">
      {toasts.value.map((t) => (
        <div key={t.id} class={`toast toast-${t.tone}`}>
          <span class="toast-icon" aria-hidden="true">
            {t.tone === 'correct' ? '✔' : t.tone === 'wrong' ? '✖' : 'ℹ'}
          </span>
          <span>
            <Rich text={t.text} />
          </span>
        </div>
      ))}
    </div>
  );
}
